import { ampli } from "@/ampli"
import { ConnectionsPreview } from "@/components/ConnectionsPreview"
import { Avatar, Text } from "@/elements"
import { FragmentType, graphql, useFragment } from "@/gql"
import { MarkerPinIcon } from "@/icons/solid"
import type { NovaSession } from "@/types"
import Link from "next/link"
import { FC, useState } from "react"
import { MessageAndInviteDialogButtons } from "./MessageAndInviteDialogButtons"

const BusinessCardHeaderFragment = graphql(`
  fragment BusinessCardHeader on IndividualCreative {
    __typename
    id
    displayName
    professionString
    locationName
    avatarInitials
    avatar168: avatar(width: 168)
    handle
    user {
      __typename
      id
      name
      uuid
      ...ConnectionsPreview
    }
    ...MessageAndInviteDialogButtons
  }
`)

interface Props {
  creative: FragmentType<typeof BusinessCardHeaderFragment> | undefined | null
  serverSession: NovaSession
  creativeUrl: string
  trackingEntryPoint: string
}

export const BusinessCardHeader: FC<Props> = props => {
  const { serverSession, creativeUrl, trackingEntryPoint } = props
  const creative = useFragment(BusinessCardHeaderFragment, props.creative)
  const [inviteToAJobDialogOpen, setInviteToAJobDialogOpen] = useState(false)

  return (
    <div className="mb-5 flex w-full flex-row items-center justify-between">
      <Link
        href={creativeUrl}
        onClick={() => {
          ampli.businessCardViewProfile({
            entry_point: trackingEntryPoint,
          })
        }}>
        <div className="flex flex-1 flex-row items-center">
          <Avatar initials={creative?.avatarInitials} src={creative?.avatar168} size="xl" />
          <div className="ml-4 flex flex-1 flex-col items-start gap-y-1">
            <Text variant="h6" maxLines={2}>
              {creative?.displayName || creative?.user.name}
            </Text>
            <Text variant="label" className="leading-[15px] text-fg-2" maxLines={2}>
              {creative?.professionString}
            </Text>
          </div>
        </div>
      </Link>
      <div className="ml-2 flex flex-shrink-0 flex-row items-center">
        <div className="mr-12 flex flex-shrink-0 flex-row items-center gap-x-8">
          <div className="flex flex-row items-center gap-x-1">
            <MarkerPinIcon height={12} className="-mr-[2px] fill-fg-4 stroke-fg-4" />
            <Text variant="body3" className="text-fg-2">
              {creative?.locationName}
            </Text>
          </div>
          <ConnectionsPreview user={creative?.user} textVariant="body2" serverSession={serverSession} />
        </div>
        <MessageAndInviteDialogButtons
          creative={creative}
          trackingEntryPoint={trackingEntryPoint}
          dialogOpen={inviteToAJobDialogOpen}
          onCloseDialog={() => setInviteToAJobDialogOpen(false)}
          onOpenDialog={() => setInviteToAJobDialogOpen(true)}
          serverSession={serverSession}
        />
      </div>
    </div>
  )
}
